// OperationTop
import {makeStyles} from "@material-ui/core/styles";

// OperationCSVUpload
export type DraftCsvUploadResultMs = {
  ad_batch_id: string;
  upload_date: string;
  upload_file_name: string;
  upload_csv_file_url: string;
  upload_err_csv_file_url: string;
  all_number: number;
  success_number: number;
  failed_number: number;
  batch_status: number;
}

export const ImmunityMessage: string[] = [
  "※各種操作欄が未記入の場合は新規登録・更新されませんので、予めご注意ください", 
  "※広告グループ・広告両方にパラメータを設定した場合、広告のパラメータのみを設定いたします",
  "※広告グループのパラメータを更新する場合、紐づく広告に設定されたパラメータが上書きされます",
  "※広告グループ更新時、紐づく広告のパラメータを更新したくない場合、パラメータ欄の記載内容は現在設定されている内容のまま更新処理をしてください。「未記入」で更新処理を実施した場合、紐づく広告のパラメータが「値なし」で上書きされます",
  "※「未記入＝値なし」での更新はパラメータ部分のみです。その他項目は「未記入＝更新しない」処理となります",
  "※機種依存文字はCSVファイル保存時に「?」へ置換される場合がございます。この場合、新規登録・更新内容も「?」となりますのでご注意ください",
];